import { CompanyActions } from '@/store/company/company.actions';
import { getCompanyData } from '@/store/company/company.selectors';
import { EmployeeActions } from '@/store/employee/employee.actions';
import {
  getCompanyChangedLoadingStatus,
  getCompanyChangedStatus,
  getPasswordChangedLoadingStatus,
  getPasswordChangedStatus,
} from '@/store/employee/employee.selectors';
import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { currentYear, credits } from '@common/constants';
import { confirmPasswordValidator } from '@components/change-password/change-password.component';
import { Select2WrapperComponent } from '@components/select2-wrapper/select2-wrapper.component';
import { HelperService } from '@core/helper/helper.service';
import { CompanyItem } from '@core/interface/company';
import { AuthenticationService } from '@core/services/auth.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-change-company',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    CommonModule,
    Select2WrapperComponent,
  ],
  templateUrl: './change-company.component.html',
  styles: ``,
})
export class ChangeCompanyComponent {
  activeModal = inject(NgbActiveModal);
  public store = inject(Store);
  public service = inject(AuthenticationService);
  public translateService = inject(TranslateService);
  public helperService = inject(HelperService);
  currentYear = currentYear;
  credits = credits;
  email: string = '';
  token: string = '';
  submit: boolean = false;
  isLoading: boolean = false;
  subscription: Subscription = new Subscription();
  company_idControl = new FormControl<string>('', [Validators.required]);
  @Input() companies: CompanyItem[] = [];
  @Input() currentCompany!: number;
  @Input() userId!: number;
  constructor() {}

  ngOnInit(): void {
    this.store.dispatch(CompanyActions.loadCompanies({}));
    this.subscription.add(
      this.store.select(getCompanyData).subscribe((data) => {
        this.companies = data.companies;
      })
    );

    this.subscription.add(
      this.store
        .select(getCompanyChangedLoadingStatus)
        .subscribe((isLoading) => {
          this.isLoading = isLoading;
        })
    );

    this.subscription.add(
      this.store.select(getCompanyChangedStatus).subscribe((isUpdated) => {
        if (isUpdated) {
          this.helperService.showSuccessToastr(
            this.translateService.instant('Company changed successfully')
          );
          this.store.dispatch(EmployeeActions.resetFlags());
          this.activeModal.close(true);
        }
      })
    );
    if (this.currentCompany)
      this.company_idControl.setValue(this.currentCompany.toString());
  }
  updateCompany() {
    this.submit = true;
    if (this.company_idControl.valid) {
      this.store.dispatch(
        EmployeeActions.changeCompany({
          user_id: this.userId?.toString() ?? '',
          company_id: this.company_idControl.value ?? '',
        })
      );
    }
  }

  // check if a specific control has a specific error and if it was touched
  // hasError(controlName: string, errorName: string) {
  //   return this.company_idControl.get(controlName)?.hasError(errorName);
  // }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
